import { createTermTagManager } from '../../utils/createTermTagManager';

export const hasRampTagManager = createTermTagManager({
  jsonQueryKey: 'has_ramp',
  label: 'Есть пандус',
  id: 'hasRamp',
});
